export type GetGoogleVerificationSite = (countryId: number) => string;

/* Google codes depending on Country ID */
const COUNTRY_GOOGLE_VERIFICATION: Record<string, string> = {
  1: '7hqFimmN4D1Yzg7-p3P904ksiPnNqOeWWDIivOXWAl4', //DE
  2: 'dcCT48cUSGyzpUUZ3aXFu0xFD64_2i-u6SEXJdLjXHE', //NL
  3: 'xj8yEGo1gvwRhOF4BE-jep5MhiC51JDLm-6suRFh140', //AT
  4: '5evPhbYiVZd9GENF4WmNQhM6msXFKBJTq6JA4RUqAp0', //CH
  5: 'K5hrPJEuNttzBLEUPASsAN_IzMoyXPqgCm7p20U_poY', //FR
  17: 'ReerMEYi2FOQ9Lzlee6m640AC5O1DJ88hmebbq7vZOg', //LU
  16: '-kJ24PqcpA3DAbkw1NIxMj8Uh8-QDBb96bTDovM2eoU', //GB
  18: '2aobv1nQjsvkEw2jp49_GDWNVKpv6YFhP15kS7flSYo',
  47: 'TM2-Pv96vj5v2IcxkD8EJKN7eTf7Hr-504VCC_SqaIw',
  48: 'sCUxjoDo7E37qjMo9uDkQ4uMfsK2xhptP4djtVH578o',
  52: 'H1Q9zGq138GeV4clpEoh95kKbyQE8FZjb0ghRMfprFA',
  53: 'bCb8GaTlKinWFU5tCMbTVzVb2LesfW4lwNmtnifEDug',
  61: 'tRkYNe5qby-nfDacBMbdR6wyRbvO0JKtr84wRdtOEfc',
  64: 'mxSCTdlfb6DgoNoaNiSHBkG9WdGrnHGBXOBbZv066sQ',
  73: 'hJ--hNUt6dmURRDcDDlMwY-oUe9OQ4yjGErQB1Zltts',
  74: 'hJ--hNUt6dmURRDcDDlMwY-oUe9OQ4yjGErQB1Zltts',
  123: 'OrJehk0cpNRHUR65fzahj41s-v1b5f3RvX_cShGv5PA',
  135: 'OrJehk0cpNRHUR65fzahj41s-v1b5f3RvX_cShGv5PA',
};

/**
 * Retrieves the Google Site Verification code for a given country ID.
 *
 * This function supports environment-based override for testing and special deployments:
 * - If GOOGLE_SITE_VERIFICATION is set, returns that value for all countries
 * - Otherwise, returns the country-specific verification code from the lookup table
 *
 * @param countryId - The country ID to get the verification code for
 * @returns The Google Site Verification code
 *
 * @example
 * // Normal usage (production)
 * getGoogleVerificationSite(1) // Returns DE verification code
 *
 * @example
 * // Override for testing (set in .env or environment)
 * GOOGLE_SITE_VERIFICATION=test-verification-code
 * getGoogleVerificationSite(1) // Returns 'test-verification-code'
 */
export function getGoogleVerificationSite(countryId: number): string {
  // Environment override for testing or special deployments
  const override = process.env['GOOGLE_SITE_VERIFICATION'];

  if (override) {
    return override;
  }

  // Default: country-specific verification codes
  return COUNTRY_GOOGLE_VERIFICATION[countryId];
}
